'use strict'

var rat = require('big-rat')
var mul = require('big-rat/mul')

module.exports = muls

function muls(a, x) {
  var s = rat(x)
  var n = a.length
  var r = new Array(n)
  for(var i=0; i<n; ++i) {
    r[i] = mul(a[i], s)
  }
  return r
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/rat-vec/muls.js
// module id = kohW
// module chunks = 0